export default "__VITE_ASSET__ClHHUfTW__"